import { isAndroid } from "@helpers/platform";
import { useCallback, useEffect, useRef } from "react";
import { BackHandler } from "react-native";

type UsePreventBackNavigationProps = {
	enabled: boolean;
	onBackPress: () => void;
	hasFocus?: boolean;
};

export const usePreventBackNavigation = ({
	enabled,
	onBackPress,
	hasFocus = true,
}: UsePreventBackNavigationProps) => {
	const shouldNavigateRef = useRef(false);

	const allowNavigation = useCallback(() => {
		shouldNavigateRef.current = true;
	}, []);

	const handleBackPressInternal = useCallback(() => {
		onBackPress();
		return true;
	}, [onBackPress]);

	// Handle Android hardware back button
	useEffect(() => {
		if (!(enabled && isAndroid && hasFocus)) {
			return;
		}

		BackHandler.addEventListener("hardwareBackPress", handleBackPressInternal);
		const subscription = BackHandler.addEventListener(
			"hardwareBackPress",
			handleBackPressInternal,
		);

		return () => {
			subscription.remove();
		};
	}, [enabled, hasFocus, handleBackPressInternal]);

	// TODO: Revisit this is causing lot of issues with stacks
	// useEffect(() => {
	// 	if (!enabled) {
	// 		return;
	// 	}

	// 	if (!isWeb || typeof window === "undefined") {
	// 		return;
	// 	}

	// 	// Push a dummy state immediately to intercept back button
	// 	window.history.pushState(null, "", window.location.href);

	// 	const handlePopState = () => {
	// 		// If navigation was confirmed, allow it
	// 		if (shouldNavigateRef.current) {
	// 			shouldNavigateRef.current = false;
	// 			return;
	// 		}

	// 		// Prevent navigation and show confirmation dialog
	// 		window.history.pushState(null, "", window.location.href);
	// 		onBackPress();
	// 	};

	// 	const handleUrlChange = () => {
	// 		if (!shouldNavigateRef.current) {
	// 			window.history.pushState(null, "", window.location.href);
	// 		}
	// 	};

	// 	let lastUrl = window.location.href;
	// 	const urlChangeObserver = setInterval(() => {
	// 		const currentUrl = window.location.href;
	// 		if (currentUrl !== lastUrl) {
	// 			lastUrl = currentUrl;
	// 			handleUrlChange();
	// 		}
	// 	}, 1000);

	// 	window.addEventListener("popstate", handlePopState);

	// 	return () => {
	// 		window.removeEventListener("popstate", handlePopState);
	// 		clearInterval(urlChangeObserver);
	// 	};
	// }, [enabled, onBackPress]);

	return { allowNavigation };
};
